import FormPage from "./pages/FormPage";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <FormPage />
    </ErrorBoundary>
  );
}

export default App;
